import { createFileRoute, Outlet } from '@tanstack/react-router'
import { BreadCrumbs } from '@navigator/EntityPage/BreadCrumbs'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs')({
  component: RouteComponent,
})

function RouteComponent() {
  return [<BreadCrumbs key="breadcrumbs" />, <Outlet key="outlet" />]
}
